import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Drawer,
  IconButton,
  useMediaQuery,
  Menu,
  MenuItem,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTheme } from "@mui/material/styles";
import quidproLogo from "../assets/quidproLowerLogo.png";
import { useDispatch, useSelector } from "react-redux";
import DownIcon from "../assets/downIcon.png";
import "./header.css";
import { resetAttorneyData, updateStatus } from "../../redux/attorneyDataSlice";
import { supabase } from "../../supabaseClient";
import { persistor } from "../../redux/store";

const UserMenu = ({ attorneyData, handleLogout }) => {
  const menuItemStylesAuth = () => ({
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "130%",
    letterSpacing: "-0.17px",
    textAlign: "center",
    verticalAlign: "middle",
    color: "#333333",
    px: "30px",
    pr: "48px",
    py: "16px",
    mx: "20px",
    my: "10px",
    borderRadius: "8px",
  });
  const [menuAnchor, setMenuAnchor] = useState(null);
  const navigate = useNavigate();

  // Don't render if attorneyData is not loaded yet
  if (!attorneyData) {
    return null;
  }

  const handleMenuOpen = (event) => {
    setMenuAnchor(event.currentTarget);
  };
  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  return (
    <div>
      <button
        onClick={handleMenuOpen}
        className="nav-link-header outlined"
        type="button"
      >
        {attorneyData.first_name} {attorneyData.last_name}{" "}
        <img
          src={DownIcon}
          alt="Expand"
          style={{ width: "24px", height: "24px", marginLeft: "4px" }}
        />
      </button>

      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 50, horizontal: 120 }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        MenuListProps={{ sx: { borderRadius: 2, minWidth: 180 } }}
      >
        <MenuItem
          onClick={() => {
            handleMenuClose();
            navigate("/attorney/professionals");
          }}
          sx={menuItemStylesAuth()}
        >
          Add professionals to account
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleMenuClose();
            navigate("/attorney/settings");
          }}
          sx={menuItemStylesAuth()}
        >
          Settings
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleMenuClose();
            // navigate("/client/my-profile");
          }}
          sx={menuItemStylesAuth()}
        >
          Features
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleMenuClose();
            // navigate("/client/my-profile");
          }}
          sx={menuItemStylesAuth()}
        >
          Visit our Help Center
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleMenuClose();
            // navigate("/client/my-profile");
          }}
          sx={menuItemStylesAuth()}
        >
          Contact us
        </MenuItem>

        <hr
          style={{
            width: "80%",
            margin: "0 auto",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        />

        <MenuItem
          onClick={() => {
            handleMenuClose();
            handleLogout();
          }}
          sx={menuItemStylesAuth()}
        >
          Logout
        </MenuItem>
      </Menu>
    </div>
  );
};

function Header({ onlyHelp = false }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [drawerOpen, setDrawerOpen] = useState(false);
  const attorneyData = useSelector((state) => state.attorneyData.attorneyData);
  const { userId } = useParams(); // Extracts userId from the URL
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // State for attorney menu anchor
  const [menuAnchor, setMenuAnchor] = useState(null);

  // Don't render the header if attorneyData is not loaded yet
  if (!attorneyData) {
    return null;
  }

  const handleMenuOpen = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  const handleLogout = async () => {
    // Implement logout logic here (e.g., clear auth tokens, dispatch logout action)
    // navigate("/login");
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      dispatch(resetAttorneyData());
      dispatch(updateStatus("idle"));
      await persistor.purge();

      navigate("/"); // Redirect to home page after logout
    } catch (error) {
      console.error("Error logging out:", error.message);
      alert("Failed to log out. Please try again.");
    } finally {
      handleMenuClose(); // Close the menu after logout
    }
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  // New PerformanceMenu component with proper active state
  const PerformanceMenu = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const location = useLocation(); // Add this hook

    const handleClick = (e) => {
      setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleMenuItemClick = (tabName, path) => {
      setAnchorEl(null);
      navigate(path); // Use navigate instead of window.location.href
    };

    // Determine active tab based on current location
    const getActiveTab = () => {
      if (location.pathname.includes('/attorney/performance/dashboard')) return 'Dashboard';
      if (location.pathname.includes('/attorney/performance/appointment-reports')) return 'Appointment Reports';
      return '';
    };

    const menuItemStyles = (tabName) => ({
      fontFamily: "Poppins",
      fontWeight: getActiveTab() === tabName ? "bold" : 400,
      fontSize: "18px",
      lineHeight: "130%",
      letterSpacing: "-0.17px",
      textAlign: "center",
      verticalAlign: "middle",
      color: "#333333",
      px: "24px",
      py: "16px",
      mx: "20px",
      my: "10px",
      borderRadius: "8px",
    });

    return (
      <div>
        <button 
          onClick={handleClick} 
          className={`nav-link-header ${location.pathname.includes('/attorney/performance/') ? 'active' : ''}`} 
          type="button"
        >
          Performance{" "}
          <img
            src={DownIcon}
            style={{ width: "24px", height: "24px" }}
            alt="expand icon"
          />
        </button>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          disablePortal
          anchorOrigin={{
            vertical: 50,
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <MenuItem
            onClick={() =>
              handleMenuItemClick(
                "Dashboard",
                "/attorney/performance/dashboard"
              )
            }
            sx={menuItemStyles("Dashboard")}
          >
            Dashboard
          </MenuItem>
          {/* <MenuItem
            onClick={() =>
              handleMenuItemClick("Awards", "/attorney/performance/awards")
            }
            sx={menuItemStyles("Awards")}
          >
            Awards
          </MenuItem> */}
          <MenuItem
            onClick={() =>
              handleMenuItemClick(
                "Appointment Reports",
                "/attorney/performance/appointment-reports"
              )
            }
            sx={menuItemStyles("Appointment Reports")}
          >
            Appointment Reports
          </MenuItem>
        </Menu>
      </div>
    );
  };

  // NavItems renders navigation items. When not onlyHelp, it includes a clickable attorney name.
  const NavItems = () => {
    const location = useLocation();
    
    if (onlyHelp) {
      return (
        <UserMenu attorneyData={attorneyData} handleLogout={handleLogout} />
      );
    }
    
    const isActive = (path) => {
      if (path === `/attorney/${userId}/home`) {
        return location.pathname === `/attorney/${userId}/home`;
      }
      
      // Special case: "Add professionals to account" should highlight Professionals tab
      if (path === '/attorney/professionals') {
        return location.pathname === '/attorney/professionals' || 
               location.pathname === '/attorney/professionals/add';
      }
      
      // Performance tab should be highlighted for all performance-related pages
      if (path === '/attorney/performance') {
        return location.pathname.includes('/attorney/performance/');
      }
      
      // Performance tab should be highlighted for all performance-related pages
      if (path === '/performance') {
        return location.pathname.includes('/attorney/performance/');
      }

      if (path === '/attorney/case') {
        return location.pathname.includes('/attorney/inbox/');
      }
      
      return location.pathname === path;
    };
    
    return (
      <>
        <a 
          href={`/attorney/${userId}/home`} 
          className={`nav-link-header ${isActive(`/attorney/${userId}/home`) ? 'active' : ''}`}
        >
          Home
        </a>
        <a 
          href="/attorney/calendar" 
          className={`nav-link-header ${isActive('/attorney/calendar') ? 'active' : ''}`}
        >
          Calendar
        </a>
        <a 
          href="/attorney/inbox" 
          className={`nav-link-header ${isActive('/attorney/inbox') ? 'active' : ''}`}
        >
          Inbox
        </a>
        <PerformanceMenu />
        <a 
          href="/attorney/professionals" 
          className={`nav-link-header ${isActive('/attorney/professionals') ? 'active' : ''}`}
        >
          Professionals
        </a>
        <a 
          href="/attorney/sponsored" 
          className={`nav-link-header ${isActive('/attorney/sponsored') ? 'active' : ''}`}
        >
          Sponsored
        </a>
        <UserMenu attorneyData={attorneyData} handleLogout={handleLogout} />{" "}
      </>
    );
  };

  // Drawer content for mobile devices.
  const drawerContent = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        padding: "16px",
        width: "200px",
      }}
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <NavItems />
    </div>
  );

  return (
    <AppBar
      position="fixed"
      color="inherit"
      elevation={0}
      style={{ backgroundColor: "white", top: 0, zIndex: 1201 }}
    >
      <Toolbar
        className="header"
        sx={{
          justifyContent: "space-between",
          borderBottom: "1px solid #E8E9EB",
        }}
      >
        {/* Left section: Logo */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <a
            href={`/attorney/${userId}/home`}
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              src={quidproLogo}
              alt="QuidPro for Lawyers Logo"
              style={{ height: 30, marginRight: 8 }}
            />
          </a>
        </div>

        {/* Right section: Nav items or mobile Drawer */}
        {isMobile ? (
          <>
            <IconButton
              edge="end"
              color="inherit"
              onClick={toggleDrawer(true)}
              aria-label="menu"
            >
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="right"
              open={drawerOpen}
              onClose={toggleDrawer(false)}
            >
              {drawerContent}
            </Drawer>
          </>
        ) : (
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <NavItems />
          </div>
        )}
      </Toolbar>
    </AppBar>
  );
}

export default Header;
